import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { productchangeType } from 'src/app/enum/ProductchangeType';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-customer-price-update',
  templateUrl: './customer-price-update.component.html',
  styleUrls: ['./customer-price-update.component.scss']
})
export class CustomerPriceUpdateComponent implements OnInit {
  refform: FormGroup;
  cusform: FormGroup;
  isform = false;
  istable = false;
  isbox = false;
  productlist: any;
  groupedProducts: any;
  subCategorylist: any;
  filteredList1: any;
  searchTerm = "";
  Product: any;
  data: any = [];
  updateProductPrice: boolean = false
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "customername",
    "customernumber",
    "applicationNumber",
    "productrecurring",
    "monthlyfee",
    "newmonthlyfee",
    "isupdate"
  ];



  constructor(
    private formBuilder: FormBuilder,
    private ApplicationDataService: ApplicationDataService,
    private ProductService: ProductService,
    private toastr: NotificationService


  ) {

  }

  ngOnInit(): void {

    this.refform = this.formBuilder.group({
      referenceno: [""],
    });

    this.cusform = this.formBuilder.group({
      customername: [{ value: '', disabled: true }],
      customernumber: [{ value: "", disabled: true }],
      applicationNumber: [{ value: "", disabled: true }],
      productrecurring: [{ value: "", disabled: true }],
      monthlyfee: [{ value: "", disabled: true }],
      newmonthlyfee: [""],
      newproduct: [""],
      productpricing: [{ value: "", disabled: true }],
      isupdate: [false],
      debitFormId: [],
      productId: [],
      serviceProviderId: [],
      productClassification: []
    })
  }

  refresh(){
    this.cusform.reset()
    this.refform.reset()
    this.isform=false
    this.dataSource=null
    this.data=[]
  }

  search() {
    let referenceno = this.refform.value.referenceno;
    console.log(referenceno)
    this.ApplicationDataService.getRecurringApplication(referenceno).subscribe((result) => {
      let data = result

      if (data) {
        this.cusform.controls['newmonthlyfee'].setValue(null);
        this.cusform.controls['newproduct'].setValue(null);
        this.cusform.controls['productpricing'].setValue(null);
        this.cusform.get('isupdate')?.setValue(false);
        this.isbox = false
        this.isform = true;

        this.cusform.controls['customername'].setValue(data.customerName);
        this.cusform.controls['customernumber'].setValue(data.customerNumber);
        this.cusform.controls['applicationNumber'].setValue(data.applicationNumber);
        this.cusform.controls['productrecurring'].setValue(data.productRecurring);
        this.cusform.controls['monthlyfee'].setValue(data.monthlyFee);
        this.cusform.controls['debitFormId'].setValue(data.debitFormId);
        this.cusform.controls['serviceProviderId'].setValue(data.serviceProviderId);
        this.cusform.controls['productClassification'].setValue(data.productClassification);





        console.log('foemdata', this.cusform)
        var postData: any = {};
        postData.serviceProviderId = data.serviceProviderId;
        postData.existingProductId = data.productId;
        postData.productClassification = data.productClassification;
        postData.ProductChangePage = productchangeType.productchange
        this.ProductService.getAllProductByServiceProviderIdAndProductId(postData).subscribe((result) => {
          console.log(result);

          this.productlist = result;
          this.productlist.forEach(item => {
            item.productCategoryName = item.productSubCategory.subCategoryName;
            this.groupedProducts = this.productlist.reduce((acc, product) => {
              let category = product.productCategoryName;
              let group = acc.find(g => g.categoryName === category);

              if (!group) {
                group = { categoryName: category, products: [] };
                acc.push(group);
              }

              group.products.push(product);
              return acc;
            }, []);
          });


        })


      }

    })

  }

  searchreset() {
    this.refform.reset()
    // this.isform = false
  }


  filteredGroupedProducts() {
    if (!this.searchTerm) {
      return this.groupedProducts;
    }

    return this.groupedProducts.map(group => ({
      categoryName: group.categoryName,
      products: group.products.filter(product =>
        product.aliasName.toLowerCase().includes(this.searchTerm.toLowerCase())

      )
    })).filter(group => group.products.length > 0);

  }


  onProductCategorySelect(event: MatSelectChange) {
    this.Product = this.productlist.find(item => item.id === event.value);
    this.cusform.controls['productrecurring'].setValue(this.Product.productId);
    this.cusform.controls['productId'].setValue(this.Product.id);
    this.cusform.controls['productpricing'].setValue(this.Product.cost);
    this.cusform.controls['newmonthlyfee'].setValue(this.Product.cost);
    this.isbox = true;
    let data = this.cusform.getRawValue();
    data.productrecurring = this.Product.productId;
    data.productpricing = this.Product.cost;
    data.newmonthlyfee = this.Product.cost;
    const index = this.data.findIndex(i => i.applicationNumber === data.applicationNumber);
    if (index !== -1) {
      data.isupdate=true
    this.cusform.controls['isupdate'].setValue(true);
      this.data[index] = data;
    } 
    this.dataSource=[...this.data]

  }
  newmonthlyfee(event: any) {
    const value = event.target.value;
    if (value != '') {
      this.cusform.get('newmonthlyfee')?.setValue(value, { emitEvent: false });
      this.isbox = true;
      this.updateTableData(value);
    }
    else
      this.isbox = false;
    // if (!this.isbox)
    // this.show(false)
  }


  updateTableData(newValue: string): void {
    console.log(newValue)
    let val=this.cusform.getRawValue()
    this.dataSource = this.dataSource.map(item =>
      item.applicationNumber ===val.applicationNumber 
        ? { ...item, newmonthlyfee: newValue }
        : item
    );
    
  }



  show(event: boolean, value?) {
    console.log('clicked', event)
    // this.cusform.get('isupdate')?.setValue(event, { emitEvent: false });
    let val = this.cusform.getRawValue()
    if (event) {
      this.istable = true;
      let validate = this.data?.some(i => i.applicationNumber == val.applicationNumber)
      if (!validate) {
        this.data.push(val)
        this.dataSource = [...this.data];
        console.log(this.dataSource)
      }
    }
    else{
      event = false
    // remove data by tabel check
    if (value) {
      this.data = this.data.filter(i => i.applicationNumber !== value.applicationNumber);
      this.dataSource = [...this.data];
      if (val.applicationNumber == value.applicationNumber)
        this.cusform.get('isupdate')?.setValue(event, { emitEvent: false });
    }
// remove data by the above checkbox
    else {
      this.data = this.data.filter(i => i.applicationNumber !== val.applicationNumber);
      this.dataSource = [...this.data];
    }
    // this.cusform.controls['isupdate'].setValue(false);
}

  }
  onsubmit() {
    // console.log(this.cusform.getRawValue())
    // let cleanedFormData = this.getNonNullValues();
    // console.log(cleanedFormData)
    this.ApplicationDataService.recurringNewCost(this.data).subscribe((result) => {
      if (result)
        this.toastr.showSuccess("Saved Successfully");
 this.refresh()
    })
  }

  getNonNullValues(): any {
    const rawValues = this.cusform.getRawValue();
    const filteredValues = Object.fromEntries(
      Object.entries(rawValues).filter(([key, value]) => value !== "" && value !== undefined)
    );
    return [filteredValues];
  }
}